const KEY = 'popup:attribution'

function safeRead() {
  try {
    return localStorage.getItem(KEY)
  } catch {
    return null
  }
}

function safeWrite(value) {
  try {
    localStorage.setItem(KEY, value)
  } catch {
    /* ignore */
  }
}

function safeRemove() {
  try {
    localStorage.removeItem(KEY)
  } catch {
    /* ignore */
  }
}

/**
 * Write attribution token. Called when user clicks a CTA in the pop-up.
 * @param {string} popupId
 * @param {number} ttl - milliseconds the token stays valid
 * @param {string|null} [convertTarget] - optional CSS selector for the
 *   specific form on the destination page that should count as the
 *   conversion (default: any form succeeds)
 */
export function setAttribution(popupId, ttl, convertTarget = null) {
  safeWrite(JSON.stringify({
    popup_id: popupId,
    timestamp: Date.now(),
    ttl,
    convert_target: convertTarget
  }))
}

/**
 * Read attribution token if present and within TTL.
 * Clears expired tokens as a side-effect.
 * @returns {{ popup_id: string, age_ms: number } | null}
 */
export function readAttribution() {
  const raw = safeRead()
  if (!raw) return null
  let parsed
  try {
    parsed = JSON.parse(raw)
  } catch {
    safeRemove()
    return null
  }
  if (!parsed || typeof parsed.timestamp !== 'number' || typeof parsed.ttl !== 'number') {
    safeRemove()
    return null
  }
  const age = Date.now() - parsed.timestamp
  if (age >= parsed.ttl) {
    safeRemove()
    return null
  }
  return {
    popup_id: parsed.popup_id,
    age_ms: age,
    convert_target: parsed.convert_target ?? null
  }
}

/**
 * Remove the attribution token (called after firing popup_converted).
 */
export function clearAttribution() {
  safeRemove()
}
